import * as Yup from 'yup';

// Search Enquiries validation schema
export const SearchEnquiriesSchema = Yup.object().shape({
  endDate: Yup.date().test(
    'dateToTest',
    'To date should be after than from date',
    function (value: any) {
      const { startDate } = this.parent;
      if (value && startDate && startDate.isAfter(value)) return false;
      return true;
    }
  ),
  datesSelection: Yup.string()
    .required('Dates is required')
    .test(
      'validate-valid-date-selection',
      'Please choose an option',
      function (value: any) {
        const { enquiryAttributes } = this.parent;
        if (value) {
          if (enquiryAttributes === 'enquiry_at') {
            if (
              value === 'next_90' ||
              value === 'next_30' ||
              value === 'next_7'
            ) {
              return false;
            } else {
              return true;
            }
          }
        }
        return true;
      }
    )
});
